const ApplyFilterButtons = ({
    onApplyFilterProv,
    onApplyFilterDepto,
    onApplyFilterAllCountry,
    onApplyFilterCountryZip,
    disabledProv,
    disabledDepto,
}) => {
    return (
        <div id="cont-applyFilter" className="mt-3">
            <h3 className="titles-form font-mpb">Opciones de consulta / validación:</h3>
            <p className="text-muted small mb-1">
                Las opciones de Departamento y Provincia únicamente están habilitadas desde el periodo 2021_2.
            </p>
            <div className="row text-center">
                <div className="col-12 col-sm-6 col-md-3">
                    <button
                        className="btn btn-outline-primary mt-2 w-100 btn-prop Pantone7406C"
                        id="applyFilterProv"
                        onClick={onApplyFilterProv}
                        type="button"
                        disabled={disabledProv}
                    >
                        Provincia
                    </button>
                </div>
                <div className="col-12 col-sm-6 col-md-3">
                    <button
                        className="btn btn-outline-success mt-2 w-100 btn-prop Pantone2935C"
                        id="applyFilterDepto"
                        onClick={onApplyFilterDepto}
                        type="button"
                        disabled={disabledDepto}
                    >
                        Departamento
                    </button>
                </div>
                <div className="col-12 col-sm-6 col-md-3">
                    <button
                        className="btn btn-outline-warning mt-2 w-100 btn-prop Pantone376C"
                        id="applyFilterAllCountry"
                        onClick={onApplyFilterAllCountry}
                        type="button"
                    >
                        Todo el País (Provincias)
                    </button>
                </div>
                <div className="col-12 col-sm-6 col-md-3">
                    <button
                        className="btn btn-outline-info mt-2 w-100 btn-prop"
                        id="applyFilterCountryZip"
                        onClick={onApplyFilterCountryZip}
                        type="button"
                    >
                        País (Archivo ZIP)
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ApplyFilterButtons;
